import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {dist, getClientXY} from "../utils/commonUtility";
import {action, observable} from "mobx";
import Draggable from "react-draggable";
import {isDesktop} from "../utils/screenUtility";
import "./withDraggable.scss";
import {TIME_TO_DRAG} from "../stores/DragStore";
import classNames from 'classnames';

/**
 *
 *
 */

export function withDraggable({cancel, handle, bounds, axis, withInitialPos = true}) {
    return function (WrappedComponent) {
        return @inject('dragStore') @observer class extends Component {
            static displayName = "withDraggable";

            @observable dragMode = isDesktop();
            @observable dragged = false;
            firstTouch = null;
            dragTimestamp = null;
            clickY = null;
            internalBounds = bounds;

            componentWillUnmount() {
                if (this.node) {
                    this.node.removeEventListener('touchstart', this.handleTouchStart);
                    this.node.removeEventListener('touchmove', this.handleTouchMove);
                    this.node.removeEventListener('touchend', this.handleDragEnd);
                    this.node.removeEventListener('touchcancel', this.handleDragEnd);
                }
            }

            setBounds = (bounds) => {
                this.internalBounds = bounds;
            }

            @action handleTouchStart = (e) => {
                // console.log('touch start')
                this.dragTimestamp = Date.now();
                this.firstTouch = getClientXY(e);
                if (this.dragMode) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            }

            @action handleDragStart = (e) => {
                try {
                    // console.log('drag start')
                    this.dragTimestamp = Date.now();
                    this.firstTouch = getClientXY(e);
                    const rect = (e.target.closest('.draggable-wrapper') || e.target).getBoundingClientRect();

                    let clientY = e.clientY;
                    if (isNaN(clientY) && e.touches && e.touches.length > 0) {
                        clientY = e.touches[0].clientY;
                    }
                    this.clickY = clientY - rect.top;  //y position within the element.
                    // console.log('drag start end', this.clickY)
                } catch (err) {
                    console.log(err);
                }
            }

            @action handleTouchMove = (e) => {
                // e.stopPropagation();
                // console.log('touchmove')
                if (!isDesktop() && !this.dragMode) {
                    // console.log('before', Date.now() - this.dragTimestamp >= TIME_TO_DRAG, dist(this.firstTouch, getClientXY(e)))
                    if (Date.now() - this.dragTimestamp >= TIME_TO_DRAG && dist(this.firstTouch, getClientXY(e)) <= 100) {
                        // console.log('I AM HERE')
                        let initEvent = Object.assign({}, {touches: e.touches, targetTouches: e.targetTouches, changedTouches: e.changedTouches});
                        this.dragMode = true;
                        setTimeout(() => {
                            try {
                                // console.log('creating syn event')
                                let event = new TouchEvent('touchstart', initEvent);
                                if (initEvent.touches && initEvent.touches.length > 0 && initEvent.touches[0].target) {
                                    // console.log('dispatching')
                                    initEvent.touches[0].target.dispatchEvent(event);
                                    // todo do this properly
                                    const mainAppContent = document.getElementById("main-app-content");
                                    if (mainAppContent) {
                                        // console.log('main app conent found')
                                        mainAppContent.style['overflow-y'] = 'hidden';
                                        setTimeout(() => {
                                            mainAppContent.style['overflow-y'] = 'auto';
                                        }, 10)
                                    }
                                }
                            } catch (err) {
                                console.log(err)
                            }
                        })
                    }
                }
                return false;
            }

            @action handleDrag = () => {
                const {dragStore} = this.props;

                if (!this.dragged) {
                    this.dragged = true;
                    dragStore.setSource(this.props.entity || this.props.project || this.props.id, this.props.type);
                }
            }

            @action handleDragEnd = () => {
                // console.log('handleDragEnd');
                this.dragged = false;
                this.dragTimestamp = null;
                this.dragMode = isDesktop();
                this.firstTouch = null;
                this.clickY = null;
                setTimeout(() => {
                    this.props.dragStore.clear();
                })
            }

            setRef = (node) => {
                this.node = node;
                if (node) {
                    // node.addEventListener('click', this.handleOnClick);
                    if (!isDesktop()) {
                        node.addEventListener('touchstart', this.handleTouchStart, {passive: false});
                        node.addEventListener('touchmove', this.handleTouchMove);
                        node.addEventListener('touchend', this.handleDragEnd);
                        node.addEventListener('touchcancel', this.handleDragEnd);
                    }
                }
            }

            handleOnClick = (e) => {
                const onClickHandler = (this.onClick || this.props.onCardClick || this.props.onClick);
                if (onClickHandler && !this.dragged) {
                    onClickHandler();
                }
            }

            setOnClick = (onClick) => {
                this.onClick = onClick;
            }

            render() {
                const {withShadow = false, withPlaceholder = false, draggable} = this.props;
                const canBeDragged = draggable === undefined ? true : draggable;// && !this.props.dragStore.disableDrag;
                const position = withInitialPos ? {x: 0, y: 0} : undefined;
                const draggableInnerClasses = classNames({
                    'draggable-inner-wrapper': true,
                    'dragged': this.dragged
                })
                return (
                    <div className={`draggable-wrapper ${withPlaceholder ? 'placeholder' : ''}`} ref={this.setRef} onClick={this.handleOnClick}>
                        <Draggable cancel={!this.dragMode ? '.draggable-inner-wrapper' : cancel} disabled={!canBeDragged} handle={handle} position={position}
                                   bounds={this.internalBounds}
                                   axis={axis}
                                   onStart={this.handleDragStart} onDrag={this.handleDrag}
                                   onStop={this.handleDragEnd}>
                            <div className={draggableInnerClasses}>
                                <WrappedComponent {...this.props} dragged={this.dragged} clickY={this.clickY} shadow={false} setOnClick={this.setOnClick}
                                                  setBounds={this.setBounds}/>
                            </div>
                        </Draggable>
                        {withShadow && <div className={`draggable-inner-shadow ${this.dragged ? 'react-draggable-dragging' : ''}`}>
                            <WrappedComponent {...this.props} shadowDragged={this.dragged} shadow={true} setOnClick={this.setOnClick}
                                              setBounds={this.setBounds}/>
                        </div>}
                    </div>)
            }
        };
    }
}
